import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countrySearch1'
})
export class CountrySearch1Pipe implements PipeTransform {

  transform(arr: any, root: any): any {
    if ( root == '' || root == null || root == undefined || root == 'Search By Area' || root == 'All' || root == 'Search By Store' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.adress1.toLowerCase().includes(root.toLowerCase())
      })
    }
  }

}
